<template>
  <md-dialog
      class="del-warn-dialog"
      :value="show"
      :closable="false"
      :mask-closable="true"
      @hide="$emit('change', false)"
  >
    <div class="title">{{ $t('registerContract3') }}</div>
    <div class="text1">
      {{ $t('commentConfirmDelete') }}
    </div>

    <div class="btn-wrap">
      <div
          class="cancel-btn"
          @click="$emit('confirm', false)"
      >{{ $t('delete') }}</div>
      <div
          class="confirm-btn"
          @click="$emit('cancel')"
      >{{ $t('cancel') }}</div>
    </div>
  </md-dialog>
</template>

<script>
import { Dialog } from 'mand-mobile';
export default {
  name: 'DelWarn',
  model: {
    prop: 'show',
    event: 'change'
  },
  components: {
    [Dialog.name]: Dialog
  },
  props: {
    show: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
    };
  },
  created () {
  }
};
</script>

<style lang="scss">
.del-warn-dialog {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000001 !important;

  .md-dialog-content {
    width: 271px !important;

    .md-dialog-body {
      padding: 20px 0 0 ;

      .title {
        font-weight: 600;
        font-size: 18px;
        line-height: 25px;
        padding: 0 20px;
        text-align: center;
        color: #fff;
        margin-bottom: 24px;
      }

      .text1 {
        font-weight: 400;
        font-size: 14px;
        padding: 0 20px;
        line-height: 20px;
        text-align: center;
        color: hsla(0,0%,100%,.9);
        margin-bottom: 22px;

      }

      .btn-wrap {
        display: flex;
        border-top: solid 1px #F3F4F7;

        div {
          min-height: 45px;
          width: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 400;
          font-size: 17px;
          line-height: 17px;
          color: #fff;

          &:first-child {
            color: rgba(225, 225, 225, 0.7);
            border-right: solid 1px #F3F4F7;
          }
        }
      }
    }
    .md-dialog-actions:after {
      display: none;
    }
  }
}
</style>
